import { render, staticRenderFns } from "./UserProjectRelation.vue?vue&type=template&id=3ef56f86&"
import script from "./UserProjectRelation.vue?vue&type=script&lang=js&"
export * from "./UserProjectRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports